/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON, FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON, } from './FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError';
import { FxIdApplicationStoreYandexGamesRedeemYandexBonusResultFromJSON, FxIdApplicationStoreYandexGamesRedeemYandexBonusResultToJSON, } from './FxIdApplicationStoreYandexGamesRedeemYandexBonusResult';
/**
 * Check if a given object implements the FxGamesLibWebRpcContractsFxGamesResponseOfRedeemYandexBonusResult interface.
 */
export function instanceOfFxGamesLibWebRpcContractsFxGamesResponseOfRedeemYandexBonusResult(value) {
    if (!('Success' in value) || value['Success'] === undefined)
        return false;
    if (!('Data' in value) || value['Data'] === undefined)
        return false;
    return true;
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfRedeemYandexBonusResultFromJSON(json) {
    return FxGamesLibWebRpcContractsFxGamesResponseOfRedeemYandexBonusResultFromJSONTyped(json, false);
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfRedeemYandexBonusResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Success': json['Success'],
        'Data': FxIdApplicationStoreYandexGamesRedeemYandexBonusResultFromJSON(json['Data']),
        'Error': json['Error'] == null ? undefined : FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON(json['Error']),
    };
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfRedeemYandexBonusResultToJSON(json) {
    return FxGamesLibWebRpcContractsFxGamesResponseOfRedeemYandexBonusResultToJSONTyped(json, false);
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfRedeemYandexBonusResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Success': value['Success'],
        'Data': FxIdApplicationStoreYandexGamesRedeemYandexBonusResultToJSON(value['Data']),
        'Error': FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON(value['Error']),
    };
}
//# sourceMappingURL=FxGamesLibWebRpcContractsFxGamesResponseOfRedeemYandexBonusResult.js.map